import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  KnockOrderItemType,
  ORDER_CANCLE_STATUS,
} from "../../../../recoil/type";
import { getDeliveryComment } from "../../../../utils/StatusComment";
import { getRecoil, setRecoil } from "recoil-nexus";
import { chatState, newChatListState } from "../../../../recoil/chat";
import DirectMessageController from "../../../../controller/DirectMessageController";

// 좌측 도넛 Status

interface DeliveryStatusButtonProps {
  props: KnockOrderItemType;
  deliveryStatus: number;
  completeDifferTime: number;
  remainTime: number;
}

let interval: any;

const DeliveryStatusButton = ({
  props,
  deliveryStatus,
  completeDifferTime,
  remainTime,
}: DeliveryStatusButtonProps) => {
  const [isBlink, setIsBlink] = useState<boolean>(false);

  const getFilterChatOrder = () => {
    return getRecoil(newChatListState).findIndex(
      (item) =>
        item.order_id === props.order_id &&
        item.order_seq === props.child.order_seq &&
        item.store_id === props.store_id
    ) > -1
      ? true
      : false;
  };

  const createChatRoom = async () => {
    try {
      const oParams = {
        contact_person: props.store_name,
        contact_person_type: "STORE",
        store_id: props.store_id,
        order_id: props.order_id,
        order_seq: props.child.order_seq,
      };

      const response =
        await DirectMessageController.createChatRoomWithoutAreaId(oParams);

      if (response && response.data) {
        const oRes = response.data;
        if (oRes.data) {
          setRecoil(chatState, (prev) => ({
            ...prev,
            cs_id: oRes.data.cs_id,
            chat_id: oRes.data.cs_id,
            area_name: props.store_name,
            direct_open: true,
          }));
        }
      }
    } catch (err) {
      console.log("err-->", err);
    }
  };

  const getChatRoomData = async () => {
    try {
      const oParams = {
        store_id: props.store_id,
        order_id: props.order_id,
        order_seq: props.child.order_seq,
        reader_type: "STORE",
      };

      const response = await DirectMessageController.getChatRoomData(oParams);

      if (response && response.data) {
        const oRes = response.data;
        console.log("getChatRoomData", oRes.data);
        if (oRes.data) {
          if (oRes.data.chatRoom) {
            setRecoil(chatState, (prev) => ({
              ...prev,
              cs_id: oRes.data.chatRoom.cs_id,
              chat_id: oRes.data.chatRoom.cs_id,
              area_name: oRes.data.chatRoom.area_name,
              direct_open: true,
            }));
          } else {
            createChatRoom();
          }
          setRecoil(newChatListState, (prev) => [
            ...prev.filter(
              (item) =>
                !(
                  item.order_id === props.order_id &&
                  item.order_seq === props.child.order_seq &&
                  item.store_id === props.store_id
                )
            ),
          ]);
        }
      }
    } catch (err) {
      console.log("err-->", err);
    }
  };

  useEffect(() => {
    const startBlink = () => {
      interval = setInterval(() => {
        setIsBlink((prevState) => !prevState);
      }, 600);
    };
    startBlink();

    return () => {
      setIsBlink(false);
      clearInterval(interval);
    };
  }, []);

  const DeliveryStatusButton = useMemo(() => {
    return (
      <div className="circleWrap">
        <div
          className="donut"
          style={{
            background: `conic-gradient(#4dd2ae 0% ${
              deliveryStatus * 25
            }%, #efefef ${deliveryStatus * 25}% 100%)`,
          }}
        >
          {props.child.order_status === ORDER_CANCLE_STATUS ? (
            <div className="circleContent cancel">
              <h3 className={`cancel`}>결제취소</h3>
            </div>
          ) : (
            <div className="circleContent">
              <h3 className={`delivery`}>
                {getDeliveryComment(props.app_name, deliveryStatus)}
              </h3>
              {(deliveryStatus === 1 || deliveryStatus === 3) && (
                <div className="loadingDots">
                  <div className="dot" />
                  <div className="dot" />
                  <div className="dot" />
                  <div className="dot" />
                </div>
              )}
              {deliveryStatus === 4 ? (
                <div>
                  <h5 className="completeTime">
                    {moment(
                      new Date(props.child.delivery_completed_at!)
                    ).format("HH:mm")}
                  </h5>
                  <h5
                    className={`${
                      completeDifferTime > 0
                        ? "plus"
                        : completeDifferTime === 0
                        ? "completeTime"
                        : "minus"
                    }`}
                  >
                    {completeDifferTime >= 0 ? "+" : ""}
                    {completeDifferTime}분
                  </h5>
                </div>
              ) : (
                <h5 className={`delivery ${remainTime < 0 && "plus"}`}>
                  {remainTime < 0
                    ? `${Math.abs(remainTime)}분 초과`
                    : `${Math.abs(remainTime)}분 남음`}
                </h5>
              )}
            </div>
          )}
        </div>
        {getFilterChatOrder() && (
          <div
            className={`emergencyWrap ${isBlink && "blink"}`}
            onClick={getChatRoomData}
          >
            <p>긴급 연락 도착</p>
            <div className="triangle" />
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_siren.svg`}
              alt="siren"
            />
          </div>
        )}
      </div>
    );
  }, [
    props.order_id,
    props.child.order_status,
    props.child.delivery_type,
    props.child.ordered_at,
    props.child.delivery_expected_at,
    props.child.delivery_estimated_time,
    remainTime,
    completeDifferTime,
    deliveryStatus,
    isBlink,
  ]);

  return DeliveryStatusButton;
};

export default DeliveryStatusButton;
